<template>
  <div>
    <NuxtPage />
  </div>
</template>

<script>
  export default {
    name: 'None',
  }
</script>

<style scoped></style>
